let identifiedEmail = ''

function getHubSpotQueue () {
    if (typeof window === 'undefined') return null

    window._hsq = window._hsq || []
    return window._hsq
}

export function identifyHubSpotUser (email) {
    const normalizedEmail = typeof email === 'string' ? email.trim().toLowerCase() : ''

    if (!normalizedEmail) return
    if (normalizedEmail === identifiedEmail) return

    const hsq = getHubSpotQueue()
    if (!hsq) return

    identifiedEmail = normalizedEmail
    hsq.push(['identify', { email: normalizedEmail }])
}

export function trackHubSpotPageView (path) {
    const hsq = getHubSpotQueue()
    if (!hsq) return

    if (path) {
        hsq.push(['setPath', path])
    }

    hsq.push(['trackPageView'])
}

export function clearHubSpotIdentity () {
    identifiedEmail = ''
}
